// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"6d47ea7d","598":"2389342b","626":"b91f3d1a","650":"acb54cbc"}[chunkId] + ".chunk.css";
};